module.exports = __webpack_public_path__ + "img/beem-02.b93911f4.png";